import { InjectionToken } from '@angular/core';

export const HERO_FLOW_SERVICE = new InjectionToken<string>('HERO flow service', {
  providedIn : 'root',
  factory: () => 'kapa'
});
